
//Actualites.jsx
import React  from 'react' ;
import { Link } from 'react-router-dom'; // Import de Link depuis React Router
import livres from '../../asserts/images/livres2.jpg';
import cyberrobot from '../../asserts/images/cyberrobot.jpg';
import compitition from '../../asserts/images/hawiya.jpg';
import folder from '../../asserts/images/folder2.png';
import clock from '../../asserts/images/clock.png';
import '../Container/Actualites.css'
function Actualites() {
 
  return (
    <div className='actualites' >

<div className='container_card'>
         <div className='cardact'>
                <Link to='/Actualité1'>
                    <img src={compitition}  alt='livres' className='imgcard'/>
                </Link>

                <div >
                  <div className='soustitre'>
                     <img src={folder} alt='folder' style={{width:'20px' , height:'30px' , marginTop:'8px' }}/>

                    <p>Actualités</p>
                  </div>
                  <div className='titre'>
                        <Link to="/Actualité1" className='link'>L’identité numérique</Link> <br/>
                        <Link to="/" className='date'>
                        <img src={clock} alt='folder' style={{width:'20px' , height:'22px' , marginTop:'0px' }}/>
                         <span>5 février 2024</span> 
                          </Link>

                  </div>
                </div>
            </div>
            <div className='cardact'>
                <img src={livres}  alt='livres' className='imgcard'/>
                <div >
                  <div className='soustitre'>
                    <img src={folder} alt='folder' style={{width:'20px' , height:'30px' , marginTop:'8px' }}/>
                    <p>Actualités</p>
                  </div>
                  <div className='titre'>
                        <Link to="/" className='link'>Foire du livre</Link> <br/>
                        <Link to="/" className='date'>
                        <img src={clock} alt='folder' style={{width:'20px' , height:'22px' , marginTop:'0px' }}/>
                         <span>7 décembre 2023</span> 
                          </Link>

                  </div>
                </div>
            </div>
            <div className='cardact'>
                <img src={cyberrobot}  alt='livres' className='imgcard'/>
                <div >
                  <div className='soustitre'>
                    <img src={folder} alt='folder' style={{width:'20px' , height:'30px' , marginTop:'8px' }}/>
                    <p>Actualités</p>
                  </div>
                  <div className='titre'>
                        <Link to="/" className='link'>Cyber Robot ISIMM</Link> <br/>
                        <Link to="/" className='date'>
                        <img src={clock} alt='folder' style={{width:'20px' , height:'22px' , marginTop:'0px' }}/>
                         <span>4 mars 2023</span> 
                          </Link>

                  </div>
                </div>
            </div>

            </div>
</div>   )
}

export default Actualites ;

